import { render, staticRenderFns } from "./DashboardInvoice.vue?vue&type=template&id=665b5b86"
import script from "./DashboardInvoice.vue?vue&type=script&lang=js"
export * from "./DashboardInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports